import { InsightsTimeframes, Timestamp, WeekDays } from '@griply/types';
import { timeframeDatesMap, weekdaysNumberMap } from '@griply/utils';
import { useMemo } from 'react';

export type Options = {
  today: Timestamp;
  weekStartsOn: WeekDays;
  allMonthWeeks?: boolean;
  quarterRoundedToWeeks?: boolean;
  yearRoundedToWeeks?: boolean;
  weekEndsWithStartOfDay?: boolean;
};

export const useTimeByInsightsTimeframe = (
  timeframe: InsightsTimeframes,
  {
    today,
    weekStartsOn,
    allMonthWeeks,
    quarterRoundedToWeeks,
    yearRoundedToWeeks,
    weekEndsWithStartOfDay,
  }: Options,
) => {
  return useMemo(() => {
    const extraRange =
      (timeframe === InsightsTimeframes.Week && weekEndsWithStartOfDay) ||
      (timeframe === InsightsTimeframes.Month && allMonthWeeks) ||
      (timeframe === InsightsTimeframes.Quarter && quarterRoundedToWeeks) ||
      (timeframe === InsightsTimeframes.Year && yearRoundedToWeeks) ||
      (timeframe === InsightsTimeframes.TwelveMonths && yearRoundedToWeeks);

    const {
      referenceDate,
      startDate,
      endDate,
      extraRangeStartDate,
      extraRangeEndDate,
    } = timeframeDatesMap[timeframe];

    const dateFnsWeekOptions = {
      weekStartsOn: weekdaysNumberMap[weekStartsOn],
    };
    return {
      referenceDate: referenceDate(today, dateFnsWeekOptions),
      startDate: extraRange
        ? extraRangeStartDate(today, dateFnsWeekOptions)
        : startDate(today, dateFnsWeekOptions),
      endDate: extraRange
        ? extraRangeEndDate(today, dateFnsWeekOptions)
        : endDate(today, dateFnsWeekOptions),
    };
  }, [
    allMonthWeeks,
    quarterRoundedToWeeks,
    timeframe,
    today,
    weekEndsWithStartOfDay,
    weekStartsOn,
    yearRoundedToWeeks,
  ]);
};
